<template>
  <div>
    <iframe
      id="bdIframe"
      ref="myIframe"
      :height="height"
      style="width:100%;"
      :src="src"
      frameborder="0"
      allowtransparency
    ></iframe>
  </div>
</template>

<script>
let _this = null;
export default {
  name: 'Analysis',
  data() {
    return {
      src:
        process.env.VUE_APP_METABASE_URL + process.env.VUE_APP_METABASEALL_URL,
      height: ''
    };
  },
  created() {
    _this = this;
    this.getHeight();
  },
  // mounted() {
  //   _this = this;
  //   // _this.adaptIframeHeight();
  //   window.onresize = () => {
  //     const oIframe = document.getElementById('bdIframe');
  //     try {
  //       let iDoc = oIframe.contentDocument || oIframe.document || oIframe.contentWindow;
  //       let cHeight = Math.max(iDoc.body.clientHeight, iDoc.documentElement.clientHeight);
  //       let sHeight = Math.max(iDoc.body.scrollHeight, iDoc.documentElement.scrollHeight);
  //       console.info("cHeight=" + cHeight + ", sHeight=" + sHeight);
  //       let height = Math.max(cHeight, sHeight);
  //       oIframe.style.height = height + 'px';
  //     } catch (e) {
  //       console.error("窗口大小变化时，iframe高度自适应异常！" + e);
  //       oIframe.style.height = '1000px';
  //     }
  //   };
  //   try {
  //     const erd = elementResizeDetectorMaker();
  //     let sidebarWidth = null;
  //     // 监听左侧导航栏的宽度变化
  //     erd.listenTo(document.getElementsByClassName("sidebar-container"), (element) => {
  //       sidebarWidth = element.offsetWidth;
  //       _this.$nextTick(() => {
  //         let addHeight = 210;
  //         // 导航栏收缩最小的时候，加大iframe的高度
  //         if (sidebarWidth === 54) {
  //           const oIframe = _this.$refs.myIframe;
  //           if (undefined !== oIframe) {
  //             console.info(oIframe);
  //             let oldHeight = oIframe.style.height;
  //             if (undefined !== oldHeight && oldHeight !== '100%') {
  //               oIframe.style.height = (Number(oldHeight.replace("px", ""))) + addHeight + 'px';
  //             }
  //           }
  //         }
  //         // 导航栏伸展到最大时，减少iframe的高度
  //         if (sidebarWidth === 210) {
  //           const oIframe = _this.$refs.myIframe;
  //           if (undefined !== oIframe) {
  //             console.info(oIframe);
  //             let oldHeight = oIframe.style.height;
  //             if (undefined !== oldHeight && oldHeight !== '100%') {
  //               oIframe.style.height = (Number(oldHeight.replace("px", ""))) - addHeight + 'px';
  //             }
  //           }
  //         }
  //       })
  //     })
  //   } catch (e) {
  //     console.error("监听左侧导航栏宽度变化异常！" + e);
  //     oIframe.style.height = '1000px';
  //   }
  // },
  methods: {
    getHeight() {
      let height = window.outerHeight;
      this.height = height - 230;
    },
    adaptIframeHeight() {
      console.log(111);
      const oIframe = document.getElementById('bdIframe');
      oIframe.onload = () => {
        try {
          // iframe高度自适应
          let iDoc =
            oIframe.contentDocument ||
            oIframe.document ||
            oIframe.contentWindow;
          let cHeight = Math.max(
            iDoc.body.clientHeight,
            iDoc.documentElement.clientHeight
          );
          let sHeight = Math.max(
            iDoc.body.scrollHeight,
            iDoc.documentElement.scrollHeight
          );
          let height = Math.max(cHeight, sHeight);
          oIframe.style.height = height + 'px';
          // 隐藏 Power By MetaBase
          // let footerDiv = iDoc.getElementsByClassName("EmbedFrame-footer");
          // if (footerDiv[0] !== undefined) {
          //     footerDiv[0].style.display = 'none';
          // }
        } catch (e) {
          console.error('iframe高度自适应异常！' + e);
          oIframe.style.height = '1000px';
        }
      };
    }
  }
};
</script>
